import type { IconSvgObject } from './types';

const DeveloperIcon: IconSvgObject = [
  ["path", { d: "M15 22V18.5L17.876 18.8595C18.4728 18.9341 19 18.4687 19 17.8672V14.5L21 13L19 10C19 5.58172 15.4183 2 11 2C6.58172 2 3 5.58172 3 10C3 13.5452 5.30607 16.5518 8.5 17.6016M6 16.2454V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 9.5L15.5 11L14 12.5M8 9.5L6.5 11L8 12.5M11.5 8.5L10.5 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default DeveloperIcon;
